export default __webpack_public_path__ + "static/media/whalogo.6bce210f.png";